import common from "./common";

export const adminManager = () => {
  const processSupplierChangesIndividual = (changes, supplierChanges) => {
    for (const change of supplierChanges) {
      const formattedChange = {
        id: change.id,
        type: "supplier_changes",
        old_supplier: change.old_supplier_name,
        new_supplier: change.new_supplier_name,
        export_id: change.type === "EXPORT" ? change.id_service : null,
        import_id: change.type === "IMPORT" ? change.id_service : null,
        reason: change.motive,
        comments: change.comment,
        user: change.user,
        datetime: common.formatUtcDateToLocal(change.created_at),
        orderData: {},
      };
      changes.push(formattedChange);
    }
  };

  const processBreakCombinationChanges = (changes, breakCombinationChanges) => {
    for (const change of breakCombinationChanges) {
      const formattedChange = {
        id: change.id,
        type: "break_combination_changes",
        old_supplier: change.old_supplier_name || null,
        new_supplier: change.supplier_name || null,
        export_id: change.export_id,
        import_id: change.import_id,
        reason: change.motive,
        comments: change.comment,
        user: change.user,
        datetime: common.formatUtcDateToLocal(change.created_at),
        orderData: {},
      };
      changes.push(formattedChange);
    }
  };

  const processSupplierChangesCombination = (changes, supplierChangesCombination) => {
    for (const change of supplierChangesCombination) {
      const formattedChange = {
        import_change_id: change.import_change_id,
        export_change_id: change.export_change_id,
        type: "supplier_changes",
        old_supplier: change.old_supplier_name,
        new_supplier: change.new_supplier_name,
        is_supplier_new: change.id_old_supplier,
        export_id: change.export_id,
        import_id: change.import_id,
        reason: change.motive,
        comments: change.comment,
        user: change.user,
        datetime: common.formatUtcDateToLocal(change.created_at),
        orderData: {},
      };
      changes.push(formattedChange);
    }
  };

  const processChangeRoutes = (changes, changeRoutes) => {
    for (const change of changeRoutes) {
      const formattedChange = {
        id: change.id,
        type: "change_routes",
        old_supplier: change.old_supplier_name,
        new_supplier: change.supplier_name,
        old_import: change.old_import,
        id_port: change.id_port,
        export_id: change.export_id,
        import_id: change.import_id,
        reason: change.motive,
        comments: change.comment,
        user: change.user,
        datetime: common.formatUtcDateToLocal(change.created_at),
        orderData: {},
      };
      changes.push(formattedChange);
    }
  };

  const processAvailabilityChanges = (changes, suppliersAvailability) => {
    for (const change of suppliersAvailability) {
      const formattedChange = {
        id: change.id,
        type: "availability_changes",
        supplier_name: change.supplier_name,
        availability: change.availability,
        old_availability: change.old_availability,
        id_area: change.id_area,
        id_supplier: change.id_supplier,
        reason: change.motive,
        comments: change.comment,
        user: change.user,
        datetime: common.formatUtcDateToLocal(change.created_at),
        orderData: {},
      };
      changes.push(formattedChange);
    }
  };

  const formatReviewChanges = (input) => {
    const changes = [];
    
    if (!input) {
      return changes;
    }

    processSupplierChangesIndividual(changes, input.supplier_changes_individual);
    processBreakCombinationChanges(changes, input.break_combination_changes);
    processSupplierChangesCombination(changes, input.supplier_changes_combination);
    processChangeRoutes(changes, input.change_routes);
    processAvailabilityChanges(changes, input.suppliers_availability);

    return changes;
  };

  return {
    formatReviewChanges,
  };
};

export default adminManager();
